export const AUTHORISE_EMPLOYEE = 'AUTHORISE_EMPLOYEE';
export const AUTHORISE_EMPLOYEE_ERROR = 'AUTHORISE_EMPLOYEE_ERROR';
export const AUTHORISE_EMPLOYEE_INACTIVE = 'AUTHORISE_EMPLOYEE_INACTIVE';
export const AUTHORISE_EMPLOYEE_SUCCESS = 'AUTHORISE_EMPLOYEE_SUCCESS';
export const AUTHORISE_EMPLOYEE_RETURN = 'AUTHORISE_EMPLOYEE_RETURN';
export const AUTHORISE_EMPLOYEE_RETURN_ERROR = 'AUTHORISE_EMPLOYEE_RETURN_ERROR';
export const AUTHORISE_EMPLOYEE_RETURN_SUCCESS = 'AUTHORISE_EMPLOYEE_RETURN_SUCCESS';
export const GOOGLE_LOGIN = 'GOOGLE_LOGIN';
export const GOOGLE_LOGIN_ERROR = 'GOOGLE_LOGIN_ERROR';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGOUT = 'GOOGLE_LOGOUT';
export const GOOGLE_LOGOUT_ERROR = 'GOOGLE_LOGOUT_ERROR';
export const GOOGLE_LOGOUT_SUCCESS = 'GOOGLE_LOGOUT_SUCCESS';
export const PATCH_LAST_LOGIN = 'PATCH_LAST_LOGIN';
export const PATCH_LAST_LOGIN_ERROR = 'PATCH_LAST_LOGIN_ERROR';
export const PATCH_LAST_LOGIN_SUCCESS = 'PATCH_LAST_LOGIN_SUCCESS';
export const POST_USER_TOKEN = 'SET_USER_TOKEN';
export const POST_USER_TOKEN_ERROR = 'SET_USER_TOKEN_ERROR';
export const POST_USER_TOKEN_SUCCESS = 'SET_USER_TOKEN_SUCCESS';
export const UNAUTHORISE_EMPLOYEE = 'UNAUTHORISE_EMPLOYEE';
export const UNAUTHORISE_EMPLOYEE_ERROR = 'UNAUTHORISE_EMPLOYEE_ERROR';
